import React, { useState } from 'react'
import {useNavigate } from 'react-router-dom';
import {BASE_URL} from './helper'
import Aavtar from '../images/upload-img.png';
import Header from '../components/Header';
import Footer from '../components/Footer';


export default function Createblogbyuser() {
    const navigate = useNavigate()
    const [blogdata, setblogdata] = useState({title:"", description:"", image:""})

    function capitalizeFirstLetter(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const base64 = await convertTobase64(file)
        setblogdata({...blogdata, image:base64})

    };

    const changevalue = (event) => {
        setblogdata({...blogdata,[event.target.name]:event.target.value})

    }

    const hadleSubmit = async (e) =>{
        e.preventDefault();
        const response = await fetch(`${BASE_URL}/api/createblog`,{
            method: "POST",
            headers:{
                'Content-Type':'application/json',
                'Content-Length': JSON.stringify({title:capitalizeFirstLetter(blogdata.title), description:blogdata.description, image:blogdata.image}).length.toString()
            },
            body: JSON.stringify({title:capitalizeFirstLetter(blogdata.title), description:blogdata.description, image:blogdata.image})
        });
        const json = await response.json()
        console.log(json);
        if (!json.success) {
            alert("Enter vailed data")
        }
        if (json.success) {
            alert("Your Post is Create")
            navigate('/')
        }
    }

    return (
        <div>
        <Header/>
        <div className='container cont-1'>
            <h1>Create Post</h1>
            <div>
                <label htmlFor="image-upload" style={{paddingRight:"10px"}}>Upload Image</label>
                <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                />
            </div>
            <form className="form" onSubmit={hadleSubmit}>
                <div className="form-group">
                 <img className='cont1-img' name="image"  src={blogdata.image || Aavtar } alt="Uploaded image" />
                    <label>Title</label>
                    <input className="form-control" type="text" name="title" value={blogdata.title} onChange={changevalue} />
                    <label>Post</label>
                    <textarea className="form-control" name="description" value={blogdata.description} onChange={changevalue} rows="5" cols="30"></textarea>
                </div>
                <button className="btn btn-primary mt-3" type="submit" name="button" >Publish</button>
            </form>
        </div>
        <Footer/>
    </div>
    )
}

function convertTobase64(file) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload =() =>{
            resolve(fileReader.result)
        };
        fileReader.onerror = (error) => {
            reject(error)
        }
    })
    
}


